import isEqual from 'hs-lodash/isEqual';
import { combineFilters, combineFilterStates, getInitialFiltersStateForUIMode, makeFiltersState, removeFilterGroups } from 'framework-listing-lib/utils/filters';
import { createStore } from './zustand';
import { INITIAL_FILTER_STATE } from '../../constants/filters';
import { updateFilterGroupsForBUNav, updateQuickFiltersForBUNav } from '../businessUnits/utils';
function resolveFiltersUpdate(update, prev) {
  return typeof update === 'function' ? update(prev) : update;
}
export function createFilterStore() {
  return createStore((set, __get, __api) => ({
    filtersState: INITIAL_FILTER_STATE,
    filterStateSource: 'other',
    deletedObjects: [],
    hasUsedQueryParams: false,
    shouldSyncWithSessionStorage: false,
    setQuery: query => set(state => {
      state.filtersState.query = query;
      state.filtersState.pagination.offset = 0;
    }),
    setSort: sort => set(state => {
      state.filtersState.sort = sort;
      state.filtersState.pagination.offset = 0;
    }),
    setPagination: pagination => set(state => {
      state.filtersState.pagination = pagination;
    }),
    setDeletedObjects: update => set(state => {
      state.deletedObjects = typeof update === 'function' ? update(state.deletedObjects) : update;
    }),
    initializeFiltersState: ({
      currentView,
      uiMode,
      initialFilter
    }) => set(state => {
      const newFiltersState = currentView ? makeFiltersState({
        initialFilter,
        currentView,
        uiMode
      }) : getInitialFiltersStateForUIMode({
        initialFilter,
        uiMode
      });
      const hasNoChanges = isEqual(state.filtersState, newFiltersState);
      if (!hasNoChanges) {
        state.filtersState = newFiltersState;
        state.filterStateSource = 'other';
      }
    }),
    updateInitialFilters: ({
      initialFilter,
      uiMode
    }) => set(state => {
      const newFiltersState = combineFilterStates({
        initialFilter,
        newFilter: state.filtersState,
        uiMode
      });
      const hasNoChanges = isEqual(state.filtersState, newFiltersState);
      if (!hasNoChanges) {
        state.filtersState = newFiltersState;
        state.filterStateSource = 'other';
      }
    }),
    consumeQueryParams: ({
      currentView,
      urlParams,
      uiMode,
      initialFilter
    }) => set(state => {
      const newFilter = currentView ? makeFiltersState({
        initialFilter,
        currentView: Object.assign({}, currentView, {
          filterGroups: combineFilters(currentView.filterGroups, urlParams.filterGroups),
          filters: [...currentView.filters, ...urlParams.filters],
          quickFilters: [...currentView.quickFilters, ...urlParams.quickFilters]
        }),
        uiMode
      }) : Object.assign({}, state.filtersState, {
        filterGroups: combineFilters(state.filtersState.filterGroups, urlParams.filterGroups),
        quickFilters: [...state.filtersState.quickFilters, ...urlParams.quickFilters]
      });
      state.hasUsedQueryParams = true;
      if (!isEqual(state.filtersState, newFilter)) {
        state.filtersState = newFilter;
        state.filterStateSource = 'other';
      }
    }),
    setFilters: (update, {
      source
    } = {
      source: 'other'
    }) => set(state => {
      const newFilters = resolveFiltersUpdate(update, state.filtersState);
      if (isEqual(state.filtersState, newFilters)) {
        return;
      }
      state.filtersState = newFilters;
      state.filterStateSource = source;
      state.shouldSyncWithSessionStorage = true;
    })
  }), {
    devtools: {
      name: 'FilterStateStore'
    }
  });
}
export const filtersStateSelectors = {
  selectHasPropertyFilter: (state, {
    propertyName
  }) => state.filtersState.quickFilters.some(filterOperator => filterOperator.property === propertyName) || state.filtersState.filterGroups.some(filterGroup => filterGroup.filters.some(filterOperator => filterOperator.property === propertyName)),
  selectFilterGroups: (state, {
    hiddenFilter,
    hasBUNavIntegration
  }) => {
    const filterGroupsWithoutHiddenFilter = removeFilterGroups(state.filtersState.filterGroups, (hiddenFilter === null || hiddenFilter === void 0 ? void 0 : hiddenFilter.filterGroups) || []);
    const filterGroupsWithBUNav = updateFilterGroupsForBUNav({
      filterGroups: filterGroupsWithoutHiddenFilter,
      hasBUNavIntegration
    });
    return filterGroupsWithBUNav;
  },
  selectQuickFilters: (state, {
    hasBUNavIntegration
  }) => updateQuickFiltersForBUNav({
    quickFilters: state.filtersState.quickFilters,
    hasBUNavIntegration
  })
};